import { useState, type ReactNode } from 'react';
import type { MembershipRef } from '@fsv/data';
import './ClubLogo.css';

/**
 * The club's logo (0019) on a light tile, so a dark logo with a transparent
 * background stays readable on the dark bars. Without a logo — or when its
 * read link has expired on a long-open page — `fallback` stands there (the
 * code, the club icon), as before logos existed. Decorative: the club's name
 * stands next to it.
 */
export function ClubLogo({ club, size, fallback = null }: { club: Pick<MembershipRef, 'logoUrl'>; size: number; fallback?: ReactNode }) {
  const [broken, setBroken] = useState<string | null>(null);
  const url = club.logoUrl;
  if (!url || broken === url) return <>{fallback}</>;
  return (
    <span className="club-logo" style={{ width: size, height: size, borderRadius: Math.round(size * 0.22), padding: Math.max(2, Math.round(size * 0.08)) }} aria-hidden="true">
      <img src={url} alt="" onError={() => setBroken(url)} />
    </span>
  );
}
